import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import { useFormik } from 'formik'
import { Typography, Grid, DialogActions, DialogContent } from '@mui/material'
// import FormikControl from '../../../molecules/FormikControl'
import FormikSelect from '../../../molecules/FormikSelect'
import SaveIcon from '@mui/icons-material/Save'
import axios from 'axios'
import { handleOpenAlert } from '../../../../lib/handleAlert'
import { closePopup } from '../../../../store/popupsSlice'
import { useDispatch } from 'react-redux'
import { refreshFilter } from '../../../../lib/handleFilters'
import LoadingButton from '@mui/lab/LoadingButton'
import * as Yup from 'yup'

const ImageFactory = ({ ...values }) => {
  const dispatch = useDispatch()
  const photo_id = values.romexis_id
  const [contracts, setContracts] = useState([])
  const [components, setComponents] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    axios.post(`/photos/${photo_id}/components`, null).then((res) => {
      setContracts(res.data.contracts)
      setComponents(res.data.components)
    })
    // setFromContract(values.fromContract)
  }, [])

  const formik = useFormik({
    initialValues: {
      // photo_id: values.photo_id,
      contract_id: values.contract_id || '',
      component_id: values.component_id || '',
    },
    enableReinitialize: false,
    validationSchema: Yup.object({
      contract_id: Yup.string().required('Pole wymagane'),
      component_id: Yup.string().required('Pole wymagane'),
    }),
    onSubmit: async (component_id) => {
      setLoading(true)
      await axios
        .post(photo_id ? `/photos/${photo_id}/assign` : '/photos/store', {
          ...component_id,
        })
        .then((res) => {
          if (res.status == 200) {
            dispatch(closePopup('image-factory-popup'))
            refreshFilter('ImagesKey')
          }
          setLoading(false)
          handleOpenAlert({
            title: 'Sukces!',
            subtitle: 'Przypisano badanie',
            type: 'success',
          })
        })
        .catch((err) => {
          setLoading(false)
          handleOpenAlert(err.request)
        })
    },
  })

  return (
    <>
      <form onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
        <DialogContent dividers={true}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" component="div">
                    Wykonane badania
                  </Typography>
                </Grid>
                {contracts && (
                  <Grid item md={6} xs={12}>
                    <FormikSelect
                      variableName="contract_id"
                      value={formik.values['contract_id']}
                      labelName="Zlecenie"
                      formik={formik}
                      config={{
                        key: 'id',
                        label: 'type_name+updated_at',
                        separator: ' - ',
                      }}
                      options={contracts}
                    />
                  </Grid>
                )}
                {components && (
                  <Grid item md={6} xs={12}>
                    <FormikSelect
                      variableName="component_id"
                      value={formik.values['component_id']}
                      labelName="Badanie"
                      formik={formik}
                      config={{
                        key: 'id',
                        label: 'examination_name+dap+tooth1',
                        separator: ' - ',
                      }}
                      options={components}
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            startIcon={<SaveIcon />}
            variant="contained"
            color="primary"
            type="submit"
            // onClick={setLoading}
            loading={loading}
            loadingPosition="start"
          >
            Zapisz
          </LoadingButton>
        </DialogActions>
      </form>
    </>
  )
}

ImageFactory.propTypes = {
  values: PropTypes.object || PropTypes.array,
}

export default ImageFactory
